import { render, staticRenderFns } from "./LayoutStructureAdm.vue?vue&type=template&id=48213368"
import script from "./LayoutStructureAdm.vue?vue&type=script&lang=js"
export * from "./LayoutStructureAdm.vue?vue&type=script&lang=js"
import style0 from "./LayoutStructureAdm.vue?vue&type=style&index=0&id=48213368&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports